import { useEffect, useState } from "react";
export function useMediaQuery(mediaSize) {
  let minMax = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "min";
  let breakpoints = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    xs: 0,
    vs: 320,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1550
  };
  // Abort if it dont make sense.
  if (minMax !== "min" && minMax !== "max") {
    console.warn("useMediaQuery second argument should be 'min' or 'max', we saw: ", minMax);
  }
  if (!breakpoints[mediaSize] && !parseInt(mediaSize)) {
    console.warn("useMediaQuery called with bad query size");
  }
  let mql;
  if (typeof window !== "undefined") {
    if (minMax === "min") {
      mql = window.matchMedia(`(min-width: ${breakpoints[mediaSize] || parseInt(mediaSize)}px)`);
    }
    if (minMax === "max") {
      // Minus one so they don't both apply for a pixel
      mql = window.matchMedia(`(max-width: ${breakpoints[mediaSize] - 1 || parseInt(mediaSize)}px)`);
    }
  }
  const [value, setValue] = useState(mql ? mql.matches : undefined);
  const handler = e => {
    // console.log("handler called")
    // console.log("is at least " + mediaSize, e.matches)
    setValue(e.matches);
  };
  useEffect(() => {
    // console.log('effect firing')
    // Set a listener for each media query with abov qe handler as callback.

    if (mql) {
      mql.addListener(handler);
      // console.log('setting val:', mql.matches, mediaSize, minMax)
      setValue(mql.matches);
      return () => mql.removeListener(handler);
    }
  }, [mql, mediaSize]);
  return value;
}